exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.business-user-list-item {\n    backface-visibility: hidden;\n    transition: all 0.25s cubic-bezier(0.55, 0, 0.1, 1);\n    transform: scaleY(1);\n}\n.business-user-list-item > div:last-of-type {\n    margin-left: auto;\n}\n", ""]);

// exports
